var eventsDateFilterStart = 0;
var eventsDateFilterEnd = 0;
var eventsDateFilterType = "none";

var picker = new Pikaday({

    field: $('#filterDatePickerField')[0],
    minDate: new Date(),
    format: "D/M/Y",
    firstDay: 1,

    toString(date,format) {

        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;

    },

    i18n: {

        previousMonth : 'Vorige maand',
        nextMonth     : 'Volgende maand',
        months        : ['Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'],
        weekdays      : ['Zondag','Maandag','Dinsdag','Woensdag','Donderdag','Vrijdag','Zaterdag'],
        weekdaysShort : ['Zo','Ma','Di','Wo','Do','Vr','Za']

    },

    onSelect: function(date) {

        filterResetDateOptions();

        let now = new Date();
        let startTime = Math.round(date.getTime() / 1000) - (now.getTimezoneOffset() * 60);
        let endTime = Math.round(date.getTime() / 1000) - (now.getTimezoneOffset() * 60) + 24 * 3600 - 1;

        eventsDateFilterStart = startTime;
        eventsDateFilterEnd = endTime;
		eventsDateFilterType = "picker";

        filterEvents();
        scrollToContent();

    }

});

function filterStores() {

    let searchTerm = $("#storeSearch").val().toLowerCase();
    let selectedCategory = $("#storeCategory").val();
    let selectedCategoryString = "id_" + selectedCategory + "_cat";
    let results = 0;

    $("#horecaWinkelen .section--grid").removeClass("section--grid--limited");
    $("#horecaWinkelen .section--grid__more").addClass("hidden");

    $(".card--store").each(function(){

        let match = true;
        let keywords = $(this).attr("data-search").toLowerCase();
        let categories = $(this).attr("data-categories");

        if((searchTerm.length && keywords.indexOf(searchTerm) === -1) || (selectedCategory.length && categories.indexOf(selectedCategoryString) === -1)) {

            match = false;

        }

        if(match) {

            $(this).removeClass("hidden");
            results++;

        } else {

            $(this).addClass("hidden");

        }

    });

    if(results == 0) {

        $("#storesNoResults").addClass("active");

    } else {

        $("#storesNoResults").removeClass("active");

    }

}

function filterEvents() {

    let searchTerm = $("#eventSearch").val().toLowerCase();
    let results = 0;
    let resultsOngoing = 0;

    if(eventsDateFilterStart > 0 || searchTerm.length) {

        $("#eventsUpcoming").addClass("hidden");
        $("#eventsFiltered").removeClass("hidden");
		$("#homeHighlights").addClass("hidden");

		var $wrapper = $("#eventsOngoing");

		$wrapper.find('.list--event').sort(function(a, b) {
			return +a.dataset.timestampend - +b.dataset.timestampend;
		}).appendTo($wrapper);

    } else {

        $("#eventsUpcoming").removeClass("hidden");
        $("#eventsFiltered").addClass("hidden");
		$("#homeHighlights").removeClass("hidden");

		var $wrapper = $("#eventsOngoing");

		$wrapper.find('.list--event').sort(function(a, b) {
			return +a.dataset.timestamp - +b.dataset.timestamp;
		}).appendTo($wrapper);

    }

	if(eventsDateFilterType == "picker") {
	
		$("#eventsCinema").addClass("hidden");
	
	} else {
	
		$("#eventsCinema").removeClass("hidden");

	}

    $("#eventsFiltered .card--event").each(function(){

        let match = true;
        let timestamp = $(this).attr("data-timestamp");
        let keywords = $(this).attr("data-search");

        if(eventsDateFilterStart > 0 && !(timestamp > eventsDateFilterStart && timestamp < eventsDateFilterEnd)) {

            match = false;

        }

        if(searchTerm.length && keywords.indexOf(searchTerm) === -1) {

            match = false;

        }

        if(match) {

            results++;
            $(this).css("display","flex");

        } else {

            $(this).css("display","none");

        }

    });

    $(".list--event").each(function(){

        let match = true;
        let timestamp = $(this).attr("data-timestamp");
        let timestampEnd = $(this).attr("data-timestampend");
        let keywords = $(this).attr("data-search").toLowerCase();

        if(eventsDateFilterStart > 0 && !(timestampEnd > eventsDateFilterStart && timestamp < eventsDateFilterEnd)) {

            match = false;

        }

        if(searchTerm.length && keywords.indexOf(searchTerm) === -1) {

            match = false;

        }

        if(match) {

            resultsOngoing++;
            $(this).removeClass("hidden");

        } else {

            $(this).addClass("hidden");

        }

    });



    if(results == 0 && resultsOngoing == 0) {

        $("#eventsNoResults").addClass("active");

    } else {

        $("#eventsNoResults").removeClass("active");

    }

}

function filterResetDateOptions() {

    $("#filterDateToday,#filterDateTomorrow,#filterDateWeekend,#filterDatePicker").removeClass("active");

    eventsDateFilterStart = 0;
    eventsDateFilterEnd = 0;

}

/*

	function switchTab(index) {

		$(".homepage__filters__tabs__item:eq(" + index + ")").addClass("active").siblings().removeClass("active");
		$(".homepage__filters__content__item:eq(" + index + ")").addClass("active").siblings().removeClass("active");

		$(".homepage__hero__content__item:eq(" + index + ")").addClass("active").siblings().removeClass("active");
		$(".homepage__content__item:eq(" + index + ")").addClass("active").siblings().removeClass("active");

		var nextTab = "";
		var nextUrl = "";

		if(index == 0) {
			
			nextTab = "UITagenda Heerlen"; nextUrl = "/";

			if (typeof UitagendaPlayer !== 'undefined') { UitagendaPlayer.play(); }
			if (typeof HorecaVideoPlayer !== 'undefined') { HorecaVideoPlayer.pause(); }
			if (typeof HeerlenPlayer !== 'undefined') { HeerlenPlayer.pause(); }
		
		}

		if(index == 1) {
			
			nextTab = "Winkels & Horeca"; nextUrl = "winkels-horeca";

			if (typeof UitagendaPlayer !== 'undefined') { UitagendaPlayer.pause(); }
			if (typeof HorecaVideoPlayer !== 'undefined') { HorecaVideoPlayer.play(); }
			if (typeof HeerlenPlayer !== 'undefined') { HeerlenPlayer.pause(); }
		
		}

		if(index == 2) {
			
			nextTab = "Oók dit is Heerlen"; nextUrl = "heerlen";

			if (typeof UitagendaPlayer !== 'undefined') { UitagendaPlayer.pause(); }
			if (typeof HorecaVideoPlayer !== 'undefined') { HorecaVideoPlayer.pause(); }
			if (typeof HeerlenPlayer !== 'undefined') { HeerlenPlayer.play(); }
		
		}

		window.history.pushState(null, nextTab, nextUrl);

	}

*/

function scrollToContent() {

    $('html, body').animate({

        scrollTop: $(".homepage__filters__content").offset().top - 46

    }, 700, function() {

    });

}

$(document).ready(function(){

    $("body").removeClass("preload");

});

$("#eventsOngoingTitle").click(function(){

    if(eventsDateFilterStart == 0) {
        
        $(".list--event").removeClass("hidden");

    }

});

$(".section--grid__more__button").click(function(){

    $("#horecaWinkelen .section--grid").removeClass("section--grid--limited");
    $("#horecaWinkelen .section--grid__more").addClass("hidden");

});



$(".homepage__filters__tabs__item").click(function(){

    //switchTab($(this).index());

    $("#filterDateToday,#filterDateTomorrow,#filterDateWeekend,#filterDatePicker").removeClass("active");
    $("#eventSearch").val("");
    
    $("#eventsUpcoming,#eventsUpcomingSide,#eventsUpcomingMobile").removeClass("hidden");
    $("#eventsFiltered").addClass("hidden");

    eventsDateFilterStart = 0;
    eventsDateFilterEnd = 0;

});

$(".nav__bar__open").click(function(){

    $(".nav").addClass("active");

});

$(".nav__menu__close, .nav__menu__overlay").click(function(){

    $(".nav").removeClass("active");

});

$("#filterDateToday,#filterDateTomorrow,#filterDateWeekend").click(function(){

    if($(this).hasClass("active")) {

        filterResetDateOptions();
        filterEvents();

    } else {

        picker.clear();
        filterResetDateOptions();
        $(this).addClass("active");

        eventsDateFilterStart = $(this).attr("data-start");
        eventsDateFilterEnd = $(this).attr("data-end");

        filterEvents();
        scrollToContent();

    }

});

$("#storeCategory").change(function(){

    scrollToContent();
    filterStores();

});

$("#eventSearch,#storeSearch").focus(function(){

    //scrollToContent();

});

$("#eventSearch").keyup(function(e){

    filterEvents();

});

$("#storeSearch").keyup(function(){

    filterStores();

});

$("#storeSearch,#eventSearch").keypress(function(event) {

    if (event.keyCode === 13) {

        scrollToContent();
        $(this).blur();

    }

});

$("iframe").each(function(){

    $(this).parent().addClass("has-iframe");

});


(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
    
ga('create', 'UA-53404306-8', { 'anonymizeIp': true, 'storage': 'none', 'clientId': window.localStorage.getItem('ga_clientId') });
ga(function(tracker) { window.localStorage.setItem('ga_clientId', tracker.get('clientId')); });
ga('send', 'pageview');